<input type="text" name="{{attr.name}}" placeholder="请输入" class="layui-input">
${t-select name="city_name" other="ssdf 234234" d-list='data.list'}